import { renderMediaOnWeb } from "@remotion/web-renderer";
import type { ExportStatus, TripData, VideoConfig } from "./types";
import {
    VIDEO_WIDTH,
    VIDEO_HEIGHT,
    VIDEO_FPS,
    INTRO_FRAMES,
    OUTRO_FRAMES,
} from "./types";
import { TripVideo, mapFrameCount } from "./remotion/composition";
import type { ComponentType } from "react";
import type { TripVideoProps } from "./remotion/composition";

export type ProgressCallback = (status: ExportStatus) => void;

export async function exportToMp4(
    tripData: TripData,
    config: VideoConfig,
    mapboxToken: string,
    onProgress: ProgressCallback,
): Promise<string> {
    const mapFrames = mapFrameCount(tripData, config);
    const totalFrames = INTRO_FRAMES + mapFrames + OUTRO_FRAMES;

    const inputProps: TripVideoProps = { tripData, config, mapboxToken };

    const result = await renderMediaOnWeb({
        composition: {
            id: "TripVideo",
            component: TripVideo as unknown as ComponentType<
                Record<string, unknown>
            >,
            width: VIDEO_WIDTH,
            height: VIDEO_HEIGHT,
            fps: VIDEO_FPS,
            durationInFrames: totalFrames,
            defaultProps: inputProps,
        },
        inputProps,
        container: "mp4",
        videoCodec: "h264",
        videoBitrate: 8_000_000,
        muted: true,
        // allowHtmlInCanvas uses the browser's native drawElementImage API (WebKit)
        // to capture DOM elements including WebGL canvases like MapBox GL.
        allowHtmlInCanvas: true,
        licenseKey: "free-license",
        isProduction: false,
        onProgress: ({ progress }) => {
            onProgress({ type: "recording", progress });
        },
    });

    const blob = await result.getBlob();
    const url = URL.createObjectURL(blob);
    onProgress({ type: "complete", progress: 1, downloadUrl: url });
    return url;
}
